const VoucherIssuanceStatusType = {
  INACTIVE: 0,
  ACTIVATED: 1,
  WAIT_FOR_APPROVAL: 2
}
export default VoucherIssuanceStatusType
